<template>
  <div class="war-room-post-topics">
    <WarRoomTopic
      v-for="topic in topics"
      :key="topic.slug"
      class="war-room-post-topics__topic"
      :topic="topic"
      size="small"
    />
  </div>
</template>

<script lang="ts">
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { IPostTopic } from '@/types/community';
import WarRoomTopic from '@/components/partials/war-room/WarRoomTopic/WarRoomTopic.vue';

export default Vue.extend({
  name: 'WarRoomPostTopics',
  components: {
    WarRoomTopic,
  },
  props: {
    topics: {
      type: Array,
      default: () => [],
      required: true,
    } as PropOptions<Array<IPostTopic>>,
  },
});
</script>

<style scoped lang="scss">
.war-room-post-topics {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  &__topic {
    margin-right: 8px;
    margin-bottom: 12px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
